/**
 * Gets the country name from a country code.
 *
 * @param countryCode The country code.
 */
export function getCountryNameFromCountryCode(countryCode) {
    var _a;
    try {
        return ((_a = new Intl.DisplayNames(['en'], { type: 'region' }).of(countryCode.toUpperCase())) !== null && _a !== void 0 ? _a : countryCode);
    }
    catch (error) {
        return countryCode;
    }
}
